import * as React from 'react';
import { Flex, Box, SlideFade } from '@chakra-ui/react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { useInView } from 'react-intersection-observer';

export type Image = {
  gatsbyImageData: IGatsbyImageData;
  alt: string;
};

type SectionImageProps = {
  images: [Image] | [Image, Image];
};

export const SectionImage: React.FC<SectionImageProps> = ({ images }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-300px 0px',
  });
  return (
    <>
      <SlideFade in={inView} offsetY="10px" ref={ref}>
        <Flex my={3} gridGap={4} px={3}>
          {images.map(({ gatsbyImageData, alt }) => (
            <Box key={alt}>
              <GatsbyImage
                alt={alt}
                image={gatsbyImageData}
                style={{
                  filter: 'drop-shadow(0px 24px 32px #000F2F14)',
                }}
              />
            </Box>
          ))}
        </Flex>
      </SlideFade>
    </>
  );
};
